// extracted by mini-css-extract-plugin
export default {"remove":"remove-button-remove-y54ZoH"};